import React from 'react';
import { translate } from 'react-i18next';

import Linkify from 'react-linkify';
import Avatar from '../../common/Avatar';
import Button from '../../common/Button';
import { Link } from 'react-router-dom';
import Modal from '../../common/Modal';
import Edit from '../../memos/Edit';
import * as Date from '../../utils/date';
import SendThanks from '../../memos/send-thanks';

class ListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editShareMemoModalOpen: false,
    };
  }

  handleEditShareMemoModalOpen = () => {
    this.setState({ editShareMemoModalOpen: true });
  };
  handleEditShareMemoModalClose = () => {
    this.setState({ editShareMemoModalOpen: false });
  };

  renderUser = (user = {}, projectId) => (
    <Link
      key={user._id}
      to={`/users/${user._id}`}
      className="u-display-flex u-align-items-center u-justify-content-center"
    >
      <Avatar
        data-tip={user.name}
        data-offset="{'left': 5}"
        data-for={projectId + user._id}
        className="u-margin-right"
        src={user.getSmallAvatarUrl()}
        width="55"
        height="55"
      />
      <h4 className="u-margin-bottom-none">{user.name}</h4>
    </Link>
  );

  render() {
    const { memo, t, isCurrentlyLoggedInUserMemo, currentUserId } = this.props;
    const { editShareMemoModalOpen } = this.state;

    return (
      <React.Fragment>
        <div className="u-display-flex u-align-items-center u-justify-content-between">
          <div className="u-margin-top-large u-margin-bottom-micro">
            <blockquote className="c-blockquote u-text-left u-font-italic u-weight-light u-margin-vertical-micro display-linebreak u-flex-1">
              <Linkify
                properties={{
                  target: '_blank',
                  className: 'u-color-blue-violet',
                }}
              >
                {memo.content}
              </Linkify>
            </blockquote>
            <p
              className="u-opacity-half u-text-left u-margin-bottom-none u-margin-top-tiny u-font-small"
              title={Date.getHumanizedDate(memo.createdAt)}
            >
              {Date.getHumanizedRemainingTimeTo(memo.createdAt)}
            </p>
            <SendThanks
              type="GOAL"
              currentUserId={currentUserId}
              isCurrentlyLoggedInUserMemo={isCurrentlyLoggedInUserMemo}
              memo={memo}
            />
          </div>
          {isCurrentlyLoggedInUserMemo && (
            <Button
              onClick={this.handleEditShareMemoModalOpen}
              type="button"
              styleType="edit-icon"
              data-tip={t('goal.create.editGoalTooltip')}
              className="u-align-self-start u-margin-top"
            />
          )}
        </div>

        <Modal
          isOpen={editShareMemoModalOpen}
          onRequestClose={this.handleEditShareMemoModalClose}
          title={t('goal.memo.modalTitle')}
        >
          <Edit
            user={memo.user}
            memo={memo}
            onSuccess={this.handleEditShareMemoModalClose}
            type="GOAL"
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default translate()(ListItem);



// WEBPACK FOOTER //
// ./src/goals/memos/ListItem.js